import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "../LandingPage/LandingPage.css";
import CRPContainer from "../LandingPage/Components/CRPContainer/CRPContainer";
import { URLS } from "../LandingPage/constants";

export default class CRPRoutes extends Component {
  render() {
    const path = window.location.pathname;
    return (
      <Router>
        <Switch>
          <Route path={`${URLS.BASEROUTE}`} component={CRPContainer} />
          {path === URLS.ROOT && <Redirect to={`${URLS.BASEROUTE}`} />}
        </Switch>
      </Router>
    );
  }
}
